"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undoCancel_jericho = exports.resume_jericho = exports.doPost = exports.submitCheckoutStatus_jericho = exports.submitInitiateCheckout_jericho = exports.checkoutStatusNotImplementedErrorMessage = exports.initiateCheckoutNotImplementedErrorMessage = exports.submitCheckout_jericho = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../../API/BaseApi"));
var interfaces_1 = require("../../common/interfaces");
var index_1 = require("../../../Config/index");
var index_2 = require("../../common/index");
var config_1 = require("../config");
var index_3 = require("../../../Config/index");
function submitCheckout_jericho(checkoutData, cartId) {
    var _a;
    var flow = checkoutData.flow, command = checkoutData.command, data = checkoutData.data, productType = checkoutData.productType;
    var phpCommand = config_1.commandMapping.get(command);
    //adding minimal address validation for php
    data.doAdditionalAddressValidation =
        (_a = data.doAdditionalAddressValidation) !== null && _a !== void 0 ? _a : true; // default to true if nothing is sent
    var params = {
        data: data,
        productType: productType,
        command: phpCommand,
        flow: flow,
        cartId: cartId,
    };
    var responseParams = BaseApi_1.default.doPostRequestToChegg(index_1.sibcV2Url, params);
    return (0, index_2.postRequestToCheggResponse)(responseParams);
}
exports.submitCheckout_jericho = submitCheckout_jericho;
exports.initiateCheckoutNotImplementedErrorMessage = "initiate checkout not implemented for jericho";
exports.checkoutStatusNotImplementedErrorMessage = "checkout status not implemented for jericho";
function submitInitiateCheckout_jericho(checkoutData, cartId) {
    return {
        errors: [
            {
                message: exports.initiateCheckoutNotImplementedErrorMessage,
                type: interfaces_1.ErrorType.SERVER,
                isBffError: false,
                isFatalError: true,
            },
        ],
        data: null,
    };
}
exports.submitInitiateCheckout_jericho = submitInitiateCheckout_jericho;
function submitCheckoutStatus_jericho(checkoutData, cartId) {
    return {
        errors: [
            {
                message: exports.checkoutStatusNotImplementedErrorMessage,
                type: interfaces_1.ErrorType.SERVER,
                isBffError: false,
                isFatalError: true,
            },
        ],
        data: null,
    };
}
exports.submitCheckoutStatus_jericho = submitCheckoutStatus_jericho;
var doPost = function (url, params) {
    var responseParams = BaseApi_1.default.doPostRequestToChegg(url, params);
    return (0, index_2.postRequestToCheggResponse)(responseParams);
};
exports.doPost = doPost;
var resume_jericho = function (params) {
    return (0, exports.doPost)(index_3.resumeUrl, params);
};
exports.resume_jericho = resume_jericho;
// TODO Add tests
var undoCancel_jericho = function (params) {
    return (0, exports.doPost)(index_3.undoCancelUrl, params);
};
exports.undoCancel_jericho = undoCancel_jericho;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/checkoutAPI/jericho/index.js
// module id = 3381
// module chunks = 11